import { render, staticRenderFns } from "./DepotForm.vue?vue&type=template&id=56d168c8&scoped=true"
import script from "./DepotForm.vue?vue&type=script&lang=js"
export * from "./DepotForm.vue?vue&type=script&lang=js"
import style0 from "./DepotForm.vue?vue&type=style&index=0&id=56d168c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d168c8",
  null
  
)

export default component.exports